import React from 'react';
import Toolbar from '../../components/UI/Toolbar/Toolbar';

// Styles & Assets
import styles from './ScoreAddPage.module.css';

// Components
import ButtonAdd from '../../components/UI/ButtonAdd/ButtonAdd';

// Language
import { useTranslation } from 'react-i18next';

// ScoreAddPage: handles the addition of a score. Renders a table to do that.
const ScoreAddPage: React.FC = () => {
    //TODO
    const { t } = useTranslation();

    return (
        <div className='pageContainer'>
            <Toolbar text={t('scores')} link='/home/administration/scores_management' />
            <div className={`container ${styles.containerScoreAdd}`}>
                <div>
                    <div className={styles.titleContainer}>
                        <h1 className={`${styles.title} title`}>{t('new_score')}</h1>
                        <ButtonAdd text={t('add_parameter')} reveredColors />
                    </div>
                    <div className={styles.inputContainer}>
                        <p className={styles.enterScoreLabel}>{t('enter_name_score')}:</p>
                        <input className={styles.inputScoreName} type='text'></input>
                    </div>
                    <table className={styles.tableScore}>
                        <thead>
                            <tr className={styles.headerRow}>
                                <th className={`${styles.cell} ${styles.headerCell}`}>{t('parameters')}</th>
                                <th className={`${styles.cell} ${styles.headerCell}`}>3</th>
                                <th className={`${styles.cell} ${styles.headerCell}`}>2</th>
                                <th className={`${styles.cell} ${styles.headerCell}`}>1</th>
                                <th className={`${styles.cell} ${styles.headerCell}`}>0</th>
                                <th className={`${styles.cell} ${styles.headerCell}`}>1</th>
                                <th className={`${styles.cell} ${styles.headerCell}`}>2</th>
                                <th className={`${styles.cell} ${styles.headerCell}`}>3</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td className={styles.cell}>
                                    <select></select>
                                </td>
                                <td className={`${styles.cell} redScore`}></td>
                                <td className={`${styles.cell} orangeScore`}></td>
                                <td className={`${styles.cell} yellowScore`}></td>
                                <td className={`${styles.cell} greenScore`}></td>
                                <td className={`${styles.cell} yellowScore`}></td>
                                <td className={`${styles.cell} orangeScore`}></td>
                                <td className={`${styles.cell} redScore`}></td>
                            </tr>
                        </tbody>
                    </table>
                </div>
                <div className={styles.buttonContainer}>
                    <button className='button'>{t('save_changes')}</button>
                </div>
            </div>
        </div>
    );
};

export default ScoreAddPage;